export default __webpack_public_path__ + "static/media/typemotorcycle.b20ba3a5.svg";